const main = {
  topbar: {
    home: 'ホームページ',
    setting: '設定',
    language: '言語',
    user: 'ユーザー',
    systemSetting: 'システム設定',
    version: 'バージョン'
  },
  menu: {
    homepage: 'ホームページ'
  },
  user: {
    user: 'ユーザー',
    loginTime: 'ログイン時刻',
    logout: 'ログアウト',
    profile: '個人情報'
  },
  forget: {
    back: '戻る',
    next: '次へ',
    Account_Recovery: 'アカウントの回復',
    Recover_Account_Password: 'アカウントのパスワードを回復'
  },
  signIn: 'ログイン',
  account: 'アカウント',
  password: 'パスワード',
  rememberMe: 'アカウントを保存',
  forgetPassword: 'パスワードを忘れた',
  learnMore: '瞭解詳情', //
  contactTo: '請聯繫 ', //
  error: '错误', //
  licenseVerificationFailed: '我們無法驗證此服務的授權訊息。', //
  limitationVerificationFailed: 'SPEC 文件不合法。', //
  returnToLogin: '返回登入' //
};

const systemSetting = {
  uiTheme: 'UI テーマ',
  timeZone: 'タイムゾーン',
  about: 'SaaSComposerについて',
  version: 'バージョン',
  newPwdNotSame: '新パスワードと再入力パスワードが一致しません。 ',
  changePwdSuccess: 'パスワードが正常に変更されました。',
  changePwdFailed: 'パスワードの変更に失敗しました。',
  oldPasswordError: 'パスワードの変更に失敗しました。旧パスワードが正しくありません。',
  choseTheme: 'テーマを選択',
  choseZone: 'タイムゾーンを選択',
  passwordLengthErr: '空のパスワードが許可されていません。8～20文字のパスワードを入力してください。',
  passwordError: 'パスワードが正しくありません。',
  passwordPolicyErr: '新しいパスワードはパスワードポリシーの要件を満たしていません。' +
  '8文字以上20文字以下、少なくとも1つの数字、' +
  '少なくとも1つの小文字、少なくとも1つの大文字、' +
  'および少なくとも1つの特殊文字を含める必要があります。' +
  'スペース、タブはご使用いただけません 。',
  productInfo: {
    uploadConfig: 'ここにzipファイルをクリックしてアップロードしてください',
    uploadConfigSuccess: 'アップロード成功',
    uploadConfigFailed: 'アップロードに失敗しました',
    productConfig: '製品構成',
    productDetail: '製品の詳細',
    productName: '製品名',
    productFavicon: 'ファビコン',
    pageTitle: 'ドキュメントのタイトル',
    loginPage: 'ログインページ',
    loginPageTitleUseText: 'テキストタイトルを使用',
    loginPageTitle: 'タイトルテキスト',
    loginPageSubtitle: 'サブタイトルテキスト',
    loginPageTitleImage: 'タイトルイメージ',
    loginPageTitleLogoImage: 'ロゴイメージ',
    loginPageBackground: '背景',
    loginPageBackground_1280: '背景 (1280px)',
    loginPageBackground_1920: '背景 (1920px)',
    loginPageBackground_max: '背景 (最大)',
    showForgetPwd: '\'パスワードを忘れる\'を表示',
    showLoginType: '\'ログインタイプ\'を表示',
    mainPage: 'メインページ',
    mainLogoImage: 'バナーロゴ',
    mainLogoTitle: 'バナータイトル',
    mainHeaderBgcolor: 'バナーカラー',
    enablePowerBy: '\'Powered By\'を表示',
    powerByLogo: '\'Powered By\' ロゴイメージ',
    enableWatermark: 'ウォーターマークを表示',
    watermarkLogo: 'ウォーターマークロゴイメージ',
    goToForum: 'フォーラムリンクを表示',
    goToDocument: 'ドキュメントリンクを表示'
  }
};

const versionHistory = {
  VersionHistory: 'バージョン履歴',
  version: 'バージョン',
  date: '日付',
  description: '説明',
  upgrade: 'アップグレード'
}

const userProfile = {
  username: 'ユーザー名',
  email: 'ユーザーID ',
  role: 'ロール',
  changePassword: 'パスワードの変更',
  oldPassword: '旧パスワード',
  newPassword: '新パスワード',
  confirmPassword: 'パスワードの確認入力',
  cancel: 'キャンセル',
  save: '保存'
};

const orgList = {
  name: '組織名',
  id: '組織ID',
  sketchboard: 'スケッチボード名',
  dataSource: 'データソース',
  createdBy: '作成者',
  role: 'ロール',
  user: 'ユーザー',
  search: '検索',
  enterOrgName: '組織名を入力してください。',
  add: '組織名の新規追加',
  limit: '0 組織残り',
  limitMessage: '標準バージョンには、最大{num}の組織を含めることができます。 無制限の組織（およびそれ以上）については、プロフェッショナルバージョンにアップグレードしてください。',
  view: 'プレビュー',
  manage: '管理',
  delete: '削除',
  save: '保存',
  cancel: 'キャンセル',
  alarm: '削除を確認しますか？ （組織名をもう一度入力してください）',
  rename: '名前の変更',
  remind: 'プロンプト',
  message: {
    emptyName: '空のデータソース名が許可されていません。',
    nameLengthLimit: 'ID の長さは 64 文字に制限されています。',
    deleteSuccess: '組織が正常に削除されました。',
    deleteFailed: '組織の削除に失敗しました。',
    addSuccess: '保存が正常に終了しました。',
    addFailed: '保存に失敗しました。',
    addFailedRepeatName: '組織名の追加に失敗しました。入力された組織名は既に存在しています。',
    modifySuccess: '組織が正常に変更されました。',
    modifyFailed: '組織の変更に失敗しました。',
    getDataError: '組織情報の取得に失敗しました。',
    getTotalCountError: '組織の合計数の取得に失敗',
    policyErr: '特殊文字はご使用いただけません 。'
  }
};

const dataSource = {
  chose: 'ご選択ください。',
  name: 'データソース名',
  type: 'データソースタイプ',
  search: 'データソースを検索',
  add: 'データソースを追加',
  importDataSource: 'データソースのインポート',
  advanced: 'アドバンスト',
  plugin: 'プラグイン',
  manage: '管理',
  edit: '編集',
  delete: '削除',
  save: '保存',
  confirm: '確認',
  cancel: 'キャンセル',
  alarm: '削除を確認しますか？',
  remind: 'プロンプト',
  nodeRed: 'Data-Director',
  importConfig: '構成のインポート',
  exportConfig: '構成のエクスポート',
  importPlugin: 'データソースプラグインのインポート',
  more: 'その他オプション',
  message: {
    emptyName: '空のデータソース名が許可されていません。',
    deleteSuccess: 'データソースが正常に削除されました。',
    deleteFailed: 'データソースの削除に失敗しました。',
    addSuccess: '保存が正常に終了しました。',
    addFailed: '保存に失敗しました。',
    modifySuccess: 'データソースが正常に変更されました。',
    modifyFailed: 'データソースの変更に失敗しました。',
    getDataError: 'データソース情報の取得に失敗しました。',
    policyErr: 'データソース名がポリシー要件を満たしていません。特殊文字はご使用いただけません 。',
    emptyType: '空のデータソースタイプが許可されていません。',
    emptyUrl: '空のURLが許可されていません。',
    repeatName: '入力されたデータソース名は既に存在しています。',
    connectSuccess: 'データソースに接続することが正常に終了しました。',
    connectFail: 'データソースへの接続に失敗しました。',
    nameLengthLimit: '名の長さは 64 文字に制限されています。',
    importPluginSuccess: 'プラグインのインポートが正常に終了しました。',
    importPluginFailed: 'プラグインのインポートに失敗しました。',
    deletePluginSuccess: 'プラグインが正常に削除されました。',
    deletePluginFailed: 'プラグインの削除に失敗しました。',
    downloadPluginFailed: 'プラグインのダウンロードに失敗しました。',
    existedPlugin: 'プラクインが既に存在しています。',
    invalidPlugin: 'プラグインが無効になっています。',
    invalidZIPFile: 'ZIPファイルが無効になっています。',
    invalidPluginContent: 'プラグイン・コンテンツが無効になっています。',
    PluginTooLarge: 'プラグインファイルが大きすぎます。',
    notEnableNodeRed: 'Data-Directorサービスが有効になっていません。',
    importDataSourceSuccess: 'データソースの構成が正常にインポートされました。',
    importDataSourceFailed: 'データソースの構成をインポートすることに失敗しました。',
    existedDataSourceName: 'データソース名が存在しています。既存のデータソース名を上書きしますか。',
    emptyUser: '空のユーザー名が許可されていません。',
    emptyPassword: '空のパスワードが許可されていません。',
    emptyPort: '空のポート番号が許可されていません。',
    emptyDatabase: '空のデータベースが許可されていません。',
    emptySslMode: '空のSSL Modeが許可されていません。',
    emptyIvsid: '空のIVSIDが許可されていません。',
    copySuccess: 'コピーが正常に完了しました。'
  }
};

const user = {
  addUserInfo: 'ユーザーアカウントの新規追加',
  alarm: '削除を確認しますか？',
  remind: 'プロンプト',
  name: 'ユーザーの名',
  type: 'ユーザータイプ',
  search: '検索',
  addUser: '+ ユーザーの新規追加',
  limit: '0 ユーザー残り',
  limitMessage: '標準バージョンには、最大{num}のユーザーを含めることができます。 無制限の組織（およびそれ以上）については、プロフェッショナルバージョンにアップグレードしてください。',
  manage: '管理',
  edit: '編集',
  delete: '削除',
  save: '保存',
  cancel: 'キャンセル',
  email: 'ユーザー ID ',
  select: 'ご選択ください',
  organization: '組織',
  addOrg: '+ 新規追加',
  selectOrg: '組織選択',
  selectRole: 'ロール選択',
  enterEmail: 'ユーザーIDを入力してください',
  enterPassword: 'パスワードを入力してください',
  enterPasswordAgain: 'パスワードを再入力してください',
  enterUserName: 'ユーザー名を入力してください',
  admin: '管理者',
  password: 'パスワード',
  message: {
    repeatOrg: '選択された組織は既に存在しています。選択し直してください',
    emptyOrg: '空の組織が許可されていません',
    emptyRole: '空のロールが許可されていません',
    emptyEmail: '空のユーザーIDが許可されていません',
    emptyPassword: '空のパスワードが許可されていません',
    inconsistentPassword: '新パスワードと再入力パスワードが一致しません',
    deleteSuccess: 'ユーザーが正常に削除されました',
    deleteFailed: 'ユーザーの削除に失敗しました',
    addFailedRepeatName: 'ユーザーIDの追加に失敗しました。入力された組織名は既に存在しています',
    deleteFailedLastUser: '組織には少なくとも 1 人の管理者が存在している必要があります',
    modifySuccess: 'ユーザーが正常に変更されました',
    modifyFailed: 'ユーザーの変更に失敗しました',
    addSuccess: '保存が正常に終了しました。',
    addFailed: '保存に失敗しました。',
    duplicateKey: 'ユーザーの追加に失敗しました。ユーザはすでに存在しています',
    unknownUser: 'ユーザーが見つかりませんでした。「ユーザー管理」ページでユーザーを追加してください',
    getDataError: 'ユーザー情報の取得に失敗しました',
    getUserOrgDataError: 'ユーザーバインディング情報の取得に失敗しました',
    deleteSelf: '自分自身を削除することはできません',
    emptyUserNameEmail: '空のユーザー名またはユーザIDが許可されていません',
    emailPolicyErr: 'ユーザーIDがポリシー要件を満たしていません',
    namePolicyErr: 'ユーザー名がポリシー要件を満たしていません',
    nameLengthLimit: '名の長さは 64 文字に制限されています'
  }
};

const sketchboard = {
  search: '検索',
  add: 'スケッチボードの追加',
  add3D: '3D スケッチボードの追加',
  spaceEditor: 'スペースエディター',
  limit: '0 {type}スケッチボード残り',
  limitMessage: '標準バージョンには、最大{num}{type}のスケッチボードを含めることができます。 無制限の{type}スケッチボード（およびそれ以上）については、プロフェッショナルバージョンにアップグレードしてください',
  name: 'スケッチボード名',
  displayType: 'スケッチボードのタイプ',
  createdBy: '作成者',
  view: 'プレビュー',
  edit: '編集',
  message: {
    getDataError: 'スケッチボード情報の取得に失敗しました'
  }
};

const body = {
  home: '組織管理',
  organization: '組織',
  setting: '設定',
  orgList: '組織一覧',
  userManagement: 'ユーザー管理',
  sketchboard: 'スケッチボード',
  dataSource: 'データソース',
  user: 'ユーザー',
  systemSetting: 'システム設定',
  userProfile: 'ユーザー・プリファレンスの設定',
  version: 'バージョン',
  menu: 'メニュー'
};

const homePage = {
  title: 'ホーム/組織'
};

const glb = {
  loading: '読み込み中',
  header: 'ヘッダ',
  aside: 'サイドバー',
  main: 'メイン',
  date: {
    timeQuantum: 'タイムクォンタム',
    to: 'まで',
    startDate: '開始日',
    endDate: '終了日'
  },
  search: '検索',
  placeholder: 'ご選択ください',
  apply: '適用',
  cancel: 'キャンセル'
};

const menu = {
  menuList: 'メニューリスト',
  viewPage: 'ビュー',
  saveMenu: '保存',
  addNode: 'ノードの追加',
  selectLangDetail: '言語の種類を選択し、そして項目名とスケッチボードのURLリンクを設定してください',
  folder: 'フォルダー',
  file: '項目',
  menuName: '項目名',
  sketchboardLink: 'スケッチボードのURLリンク',
  defaultOpen: 'デフォルトオン',
  logo: 'ロゴ',
  logoImage: '画像',
  limitMessage: 'カスタマイズされたロゴについては、プロフェッショナルバージョンにアップグレードしてください。',
  logoSrc: 'ソースパス',
  logoDescript: '説明',
  menu: 'メニュー',
  width: '幅',
  modify: '変更',
  cancel: 'キャンセル',
  reset: 'リセット',
  openMenu: 'デフォルトオン',
  showIcon: 'アイコンの表示',
  openSetting: '「設定」を開く',
  frameSetting: 'フレーム設定',
  changeImage: '変更',
  clearImage: 'クリア',
  language: '語言',
  openLanguage: '開啟語言切換',
  defaultLang: '預設語言',
  view: '預覽',
  openLayerView: 'レイヤーのプレビュー',
  message: {
    addSuccess: '保存が正常に終了しました',
    addFailed: '保存に失敗しました',
    loadFailed: 'メニューを読み込みに失敗しました'
  }
}

const orgSetting = {
  bimEnable: 'BIMを有効にする',
  viewLogin: '預覽登入',
  outsideResource: '外部リソース',
  saveMenu: 'プリファレンスの保存',
  message: {
    addSuccess: '保存が正常に終了しました',
    addFailed: '保存に失敗しました',
    loadFailed: 'プリファレンスの読み込みに失敗しました。デフォルトを使用します'
  }
}

const jp = {
  main,
  body,
  homePage,
  glb,
  orgList,
  dataSource,
  user,
  sketchboard,
  userProfile,
  systemSetting,
  versionHistory,
  menu,
  orgSetting
};

export default jp



// WEBPACK FOOTER //
// ./src/js/lang/jp.js